// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__M08qp","fullView":"Footer_fullView__wicGY","shimmer":"Footer_shimmer__85Dw3"};